import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DimpleDivider from '@tds/core-dimple-divider';
import Heading from '@tds/core-heading';
import ValidateLoader from '../UI/validateLoader';

import { defectManagementConfig, getEnvironment } from '../utils/request';
import Filters from './Filters';
import { DEFECTS_PER_PAGE, FILTERS_INIT_STATE } from './constants';
import { Box, ContentWrapper, TopbarWrapper } from '../design/css';
import { Container } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import Pagination from './Pagination';
import Table from './Table';

const DefectManagement = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    DEFECT_MANAGEMENT: { DEFECT_TABLE = {}, DEFECTS = '', NO_DEFECTS = '' } = {}
  } = localizedStrings;
  // States
  const [defects, setDefects] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [totalDefects, setTotalDefects] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [fetchData, setFetchData] = useState(false);

  // API Call to Fetch all Defects
  function fetchAllDefects(query = {}) {
    setPageLoading(true);
    const { sof2ApiHost } = getEnvironment();
    const url = `${sof2ApiHost}/defects/getall/${pageNumber}/${DEFECTS_PER_PAGE}`;
    const config = defectManagementConfig('get', url);
    axios({ ...config, params: query }).then(res => {
      const {
        data: { totalCount = 0, status = 1, message = '', innerData = [] }
      } = res;
      if (status === 1 && message) {
        setDefects(innerData);
        setTotalDefects(totalCount);
        setFetchData(false);
        setPageLoading(false);
      }
    });
  }

  useEffect(() => {
    if (pageNumber || fetchData) fetchAllDefects();
  }, [pageNumber, fetchData]);

  // filter data from child to parent
  const applyFilter = filter => {
    Object.keys(FILTERS_INIT_STATE).forEach(key =>
      // eslint-disable-next-line no-param-reassign
      filter[key] === '' ? delete filter[key] : filter[key]
    );
    fetchAllDefects(filter);
  };

  const reset = () => fetchAllDefects();

  return (
    <Container>
      <ContentWrapper style={{ padding: '0 4rem' }}>
        <Filters onApplyFilters={applyFilter} onResetFilters={reset} />
        <DimpleDivider />
        {pageLoading && <ValidateLoader message="Loading" />}
        {!pageLoading && !totalDefects && (
          <Heading level="h3"> {NO_DEFECTS}</Heading>
        )}
        {!pageLoading && totalDefects > 0 && (
          <Box
            style={{
              border: '1px solid #e3e3e3'
            }}
          >
            <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
              {`${DEFECTS} (${totalDefects})`}
            </TopbarWrapper>
            <Table
              setFetchData={setFetchData}
              header={DEFECT_TABLE}
              data={defects}
            />
            <Pagination
              pageNumber={pageNumber}
              totalDefects={totalDefects}
              defectsPerPage={DEFECTS_PER_PAGE}
              setPageNumber={setPageNumber}
            />
          </Box>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default DefectManagement;
